/**
 * Shared cost + trust messaging banner for AI generation dialogs.
 * Shows credit cost, estimated time, and "Credits deducted only on success" trust line.
 */

import styles from './AiDialog.module.css';

interface CostBannerProps {
  credits: number;
  timeEstimate?: string;
  loading?: boolean;
  /** Optional extra info text (e.g., duration clamping note) */
  extra?: string;
}

export function CostBanner({ credits, timeEstimate, loading, extra }: CostBannerProps) {
  return (
    <div className={styles.costBanner}>
      <div className={styles.costBannerTop}>
        <span className={styles.costBannerCredits}>
          {loading ? '...' : `${credits} credits`}
          {extra && <span className={styles.costBannerExtra}> {extra}</span>}
        </span>
        {timeEstimate && (
          <span className={styles.costBannerTime}>~{timeEstimate}</span>
        )}
      </div>
      <div className={styles.trustMessage}>
        Credits deducted only on success
      </div>
    </div>
  );
}

/** Format seconds into a human-readable estimate string */
export function formatTimeEstimate(seconds: number): string {
  if (seconds <= 0) return '';
  if (seconds < 60) return `${seconds}s`;
  const mins = Math.ceil(seconds / 60);
  const rem = seconds % 60;
  return rem > 0 ? `${mins}m ${rem}s` : `${mins}m`;
}
